// extracted by mini-css-extract-plugin
export default {"image":"ZW-z","loaded":"_W-z"};